import {GET} from "../util";
import {enumDef} from "@/common/enumDefs";

const commonUrl = "api/common/";
const url = {
    countries: `${commonUrl}countries`,
    companycountries: `${commonUrl}companycountries/:companyType`,
    legalstructures: `${commonUrl}legalstructures/:companyType/:country`,
    registercourts: `${commonUrl}registercourts`,
    currentuser: `${commonUrl}currentuser`,

    getToken: `common/getToken`,
    localeLang: `common/locale`,


};
const commonApi = {
    countries: () => {
        return GET(url.countries)
    },
    Companycountries: (companyType = enumDef.companyType.TraderCompany) => {
        return GET(url.companycountries.replace(":companyType", companyType), {});
    },
    Registercourts: (country) => {
        return GET(url.registercourts + "/" + country);
    },
    Currentuser: (params = {}) => {
        return GET(url.currentuser, params);
    },
    getLegalStructures: (companyType, country) => {
        return GET(url.legalstructures.replace(":companyType", companyType).replace(":country", country));
    },
    getToken: (params = {}) => {
        return GET(url.getToken, params);
    },
    localeLang: (params = {}) => {
        return GET(url.localeLang, params);
    },
};
export {
    commonApi
};